import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { popular_roles_helper } from "@/helpers/popular_roles_helper";
import { useLink } from "@/hooks/useLink";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import classes from "./styles.module.scss";

export const SitemapPageContentSection = ({ className }) => {
  const link = useLink();
  const locale = useLocale();
  const items = popular_roles_helper.fetch();

  return (
    <div className={clsx(className, classes.sitemap)}>
      <Container>
        <Row as="ul" className="ps-5">
          {items.map((i) => (
            <Col as="li" className="py-2" xs={12} md={6} key={i.id}>
              <a href={link("popular.roles", i.url_slug)}>
                <DynamicText
                  path={`page.popular.roles.${i.url_slug}.banner.title.${locale}`}
                >{`${i.name} Jobs`}</DynamicText>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

SitemapPageContentSection.defaultProps = {
  className: "py-4 py-md-5",
};
